import styled from 'styled-components';
import { SizeProps } from '@/types/ui';
import { getSizeStyle } from '@/utils/style/ui';

export interface Props {
  $width?: SizeProps;
  $height?: SizeProps;
  $minWidth?: SizeProps;
  $minHeight?: SizeProps;
  $maxWidth?: SizeProps;
  $maxHeight?: SizeProps;
  $rounded?: SizeProps;
}

const ImageWrapper = styled.div<Props>`
  position: relative;
  display: inline-block;
  width: ${({ theme, $width }) =>
    getSizeStyle({ theme, size: $width }) || 'unset'};
  min-width: ${({ theme, $width }) =>
    getSizeStyle({ theme, size: $width }) || 'unset'};
  max-width: ${({ theme, $width, $minWidth }) =>
    ($minWidth
      ? getSizeStyle({ theme, size: $minWidth })
      : getSizeStyle({ theme, size: $width })) || 'unset'};
  height: ${({ theme, $height, $minHeight }) =>
    ($minHeight
      ? getSizeStyle({ theme, size: $minHeight })
      : getSizeStyle({ theme, size: $height })) || 'unset'};
  min-height: ${({ theme, $height, $maxWidth }) =>
    ($maxWidth
      ? getSizeStyle({ theme, size: $maxWidth })
      : getSizeStyle({ theme, size: $height })) || 'unset'};
  max-height: ${({ theme, $height, $maxHeight }) =>
    ($maxHeight
      ? getSizeStyle({ theme, size: $maxHeight })
      : getSizeStyle({ theme, size: $height })) || 'unset'};
  border-radius: ${({ theme, $rounded }) =>
    getSizeStyle({ theme, size: $rounded }) || theme.size.zero};
  overflow: hidden;
`;

export default ImageWrapper;
